{
  "name": "logick-billetterie",
  "version": "1.25.2",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "serve:dev": "ng serve --configuration dev",
    "serve": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration dev",
    "build:crousmtp.preprod": "ng build --configuration crousmtp.preprod",
    "build:crousmtp.prod": "ng build --configuration crousmtp.prod",
    "test": "ng test",
    "lint": "eslint",
    "lint:quiet": "eslint --quiet",
    "lint:fix": "eslint --fix",
    "logick:update": "npm ls --json | jq '.dependencies | keys[]' | grep '@logick' | xargs npm install --force"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.5",
    "@angular/common": "^21.0.5",
    "@angular/compiler": "^21.0.5",
    "@angular/core": "^21.0.5",
    "@angular/forms": "^21.0.5",
    "@angular/platform-browser": "^21.0.5",
    "@angular/platform-browser-dynamic": "^21.0.5",
    "@angular/router": "^21.0.5",
    "@logick/browser": "0.14.0",
    "@logick/common": "0.13.0",
    "@logick/core-api": "1.25.3",
    "@logick/ui": "21.7.1",
    "@logick/ui-themes": "21.7.1",
    "@primeuix/themes": "^2.0.2",
    "@tailwindcss/postcss": "^4.1.18",
    "chart.js": "4.5.1",
    "nanoid": "^3.3.11",
    "primeicons": "^7.0.0",
    "primelocale": "^2.2.3",
    "primeng": "^21",
    "quill": "2.0.2",
    "rxjs": "~7.8.0",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.3",
    "@angular/cli": "^21.0.3",
    "@angular/compiler-cli": "^21.0.5",
    "@logick/devtools": "1.1.0",
    "angular-eslint": "^21.1.0",
    "eslint": "^9.39.2",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "jsdom": "^26.1.0",
    "postcss": "^8.5.6",
    "prettier": "^3.7.4",
    "tailwindcss": "^4.1.18",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.49.0",
    "vitest": "^4.0.8"
  }
}
